import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { TableDataModel } from '../../models/CommandCenterUI/TableDataModel.model';

@Component({
	selector: 'app-data-table',
	templateUrl: './data-table.component.html',
	styleUrls: ['./data-table.component.scss'],
})
export class DataTableComponent implements OnInit {
	@Input() tableDataModel: TableDataModel;
	@Output() tableDataModelChange = new EventEmitter<TableDataModel>();

	@Input() dataObject: any;
	@Output() dataObjectChange = new EventEmitter<any>();

	@Output() dataTableRowOnClickChange = new EventEmitter<any>();

	constructor(public app: AppService) {}

	ngOnInit(): void {}
}
